module.exports = __webpack_public_path__ + "static/Classroom-Activity-2-5-Exit-and-Refusal-Strategies-334c6e2af8727c38d76eaa17f9b7ff2b.pdf";